/* eslint-disable unicode-bom */
import "./Loader.scss";

const Loader = () => {
  return (
    <div className="loader-wrapper">
      <div className="loader-content">
        <h1 className="loader-logo">
          <span className="loader-initials">AR</span>
        </h1>
        <p className="loader-text">Loading...</p>
        <div className="progress-bar-container">
          <div className="progress-bar"></div>
        </div>
      </div>
    </div>
  );
};

export default Loader;